<template>
  <div v-if="showGreetingCardExtra">
    <ProductGreetingCardExtraV3
      v-for="(greetingCardExtra, i) in greetingCardExtras"
      :key="i"
      :title="greetingCardExtra.title"
      :handle="greetingCardExtra.greetingCardHandle"
      :multiple-selection="true"
      :dynamic-price="greetingCardExtra.dynamicPrice"
      :show-no-option="true"
      :show-upsell-table="i === greetingCardExtras.length - 1"
      @greeting-card-selected="getProductGrettingCardSelected"
    />
  </div>
</template>

<script lang="ts" setup>
import useProductStore from '@/store/product'
import useSettingStore from '@/store/setting'
import { onMounted, watch, computed, ref } from 'vue'
import { isProductHasTags } from '@/utils/product'
import {
  EVENT_UPDATE_GREETING_CARD_EXTRA,
  EVENT_UPDATE_GIFT_BOX_EXTRA,
  HANDLE_PRODUCT_UPSELL_WITH_GREETING_CARD,
} from '@/utils'
import EventBus from '@/services/eventbus'
import ProductGreetingCardExtraV3 from './ProductGreetingCardExtraV3.vue'

const productStore = useProductStore()
const settingStore = useSettingStore()

const productGreetingCardExtras = ref<any[]>([])
const buyGiftBox = ref(false)

const greetingCardExtras = computed(() => {
  if (!settingStore.baseProductPage?.upsellGreetingCard?.length) {
    return []
  }
  return settingStore.baseProductPage?.upsellGreetingCard.filter((item: any) =>
    isProductHasTags(productStore.product, [item?.tag || ''])
  )
})

const showGreetingCardExtra = computed(() => {
  return greetingCardExtras.value?.length > 0
})

onMounted(() => {
  watch(
    () => productGreetingCardExtras.value,
    (val) => {
      const lineItems = val.map((item: any) => ({
        merchandiseId: item.merchandiseId,
        quantity: item.quantity || 1,
        attributes: item.attributes || [],
      }))
      EventBus.trigger(EVENT_UPDATE_GREETING_CARD_EXTRA, lineItems)
    },
    { deep: true }
  )

  watch(() => buyGiftBox.value, (val) => {
    EventBus.trigger(EVENT_UPDATE_GIFT_BOX_EXTRA, val ? { checked: true } : null)
  })
})

function getProductGrettingCardSelected(data: any) {
  productGreetingCardExtras.value = productGreetingCardExtras.value.filter(
    (item: any) => item.productHandle !== data.productHandle
  )

  if (data.greetingCardVariantArrSelected?.length) {
    const selected = data.greetingCardVariantArrSelected.map((variant: any) => ({
      productHandle: data.productHandle,
      merchandiseId: variant.id,
      quantity: 1,
      attributes: [
        {
          key: HANDLE_PRODUCT_UPSELL_WITH_GREETING_CARD,
          value: productStore.product?.handle,
        },
        { key: '_Pack 1', value: '3.99' },
        { key: '_Pack 2 - 25% OFF', value: '5.99' },
        { key: '_Pack 3 - 33% OFF', value: '7.99' },
        { key: '_Pack 5 - 50% OFF', value: '9.99' },
        { key: '_product-pack', value: 'true' },
      ],
    }))
    productGreetingCardExtras.value.push(...selected)
  }
}
</script>
